import React from "react";

export default function CcSvgIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="115"
            height="115"
            viewBox="0 0 115 115"
            {...props}
        >
            <defs>
                <linearGradient
                    id="linear-gradient"
                    x1="0.5"
                    x2="0.5"
                    y2="1"
                    gradientUnits="objectBoundingBox"
                >
                    <stop offset="0" stop-color="#3a3a3a" />
                    <stop offset="1" stop-color="#5b5b5b" />
                </linearGradient>
            </defs>
            <g
                id="Groupe_32639"
                data-name="Groupe 32639"
                transform="translate(-26 -49)"
            >
                <g
                    id="Groupe_13786"
                    data-name="Groupe 13786"
                    transform="translate(26 49)"
                >
                    <circle
                        id="Ellipse_715"
                        data-name="Ellipse 715"
                        cx="57.5"
                        cy="57.5"
                        r="57.5"
                        fill={props.stopColor}
                    />
                </g>
                <g id="online-shopping" transform="translate(49.266 75.986)">
                    <path
                        id="Tracé_22357"
                        data-name="Tracé 22357"
                        d="M11.373,1.7H10.3a.475.475,0,1,0,0,.95h1.07a.475.475,0,1,0,0-.95Z"
                        transform="translate(17.909)"
                        fill={props.fill}
                    />
                    <path
                        id="Tracé_22358"
                        data-name="Tracé 22358"
                        d="M59.874,35.055c-.1-.006-.2-.008-.3-.006a4.3,4.3,0,0,0-1.452.279,3.994,3.994,0,0,0-4-3.994h-.078a4.366,4.366,0,0,0-1.676.335,3.974,3.974,0,0,0-3.826-2.709,4.471,4.471,0,0,0-1.48.279V3.575A3.579,3.579,0,0,0,43.5,0H13.393A3.582,3.582,0,0,0,9.818,3.575V14.55H8.338l-.922-2.793a1.321,1.321,0,0,0-.9-.866L2.434,9.719A1.349,1.349,0,0,0,2.1,9.691a1.315,1.315,0,0,0-1.313.95,1.358,1.358,0,0,0,.922,1.676l3.379.95L9.472,27.006,8.8,29.185A4.36,4.36,0,0,0,9.36,37.87a2.173,2.173,0,0,0,.447-.028V54.906a3.563,3.563,0,0,0,3.552,3.575H38.21a7.977,7.977,0,0,1,1.62,5.865,2.682,2.682,0,0,0,2.681,2.681H58.877a2.682,2.682,0,0,0,2.681-2.681V60.1a5.458,5.458,0,0,1,.726-2.9,11.037,11.037,0,0,0,1.368-4.5V39.295A4.015,4.015,0,0,0,59.874,35.055ZM9.427,17.232H31.211l-2.234,8.406H11.885Zm1.62,16.282a1.69,1.69,0,1,1,0-.028Zm.827-5.195h17.4a2.258,2.258,0,0,0,2.29-2.039l2.709-10.026a1.364,1.364,0,0,0-.223-1.173,1.323,1.323,0,0,0-1.061-.531H12.444V3.575a.943.943,0,0,1,.933-.95H43.5a.967.967,0,0,1,.977.95V22.4a4.436,4.436,0,0,0-1.452-.251,4.021,4.021,0,0,0-2.793,1.089,4.178,4.178,0,0,0-1.285,3.156V39.937a6.912,6.912,0,0,0-1.005-.531,3.961,3.961,0,0,0-3.659.168,3.4,3.4,0,0,0-1.368,2.877v6.814H12.444V36.586a4.493,4.493,0,0,0,1.05-1.759h8.054a4.421,4.421,0,0,0,4.161,3.044,4.371,4.371,0,1,0,0-8.741,4.421,4.421,0,0,0-4.161,3.044H13.494a4.4,4.4,0,0,0-2.039-2.486Zm12.16,5.234v-.067a1.683,1.683,0,1,1,1.676,1.7h0A1.658,1.658,0,0,1,24.034,33.553ZM13.393,55.884a.967.967,0,0,1-.95-.977V51.89H32.915v.14a4.982,4.982,0,0,0,2.178,3.854h-21.7Zm47.645-3.407A8.443,8.443,0,0,1,59.977,56,7.881,7.881,0,0,0,58.944,60.1v4.245a.06.06,0,0,1-.056.056H42.522a.06.06,0,0,1-.056-.056A10.373,10.373,0,0,0,39.9,56.386a14.233,14.233,0,0,0-2.123-1.759c-1.4-1.033-2.234-1.7-2.234-2.6V42.478c0-.363.084-.642.223-.726a1.648,1.648,0,0,1,1.229.112,3.033,3.033,0,0,1,1.955,2.849V48.9a1.313,1.313,0,1,0,2.625,0V26.392A1.431,1.431,0,0,1,42.8,24.783a1.229,1.229,0,0,1,.226-.011,1.647,1.647,0,0,1,1.005.363,1.709,1.709,0,0,1,.447,1.257V41.5a1.3,1.3,0,1,0,2.6,0V33.206a1.45,1.45,0,0,1,1.262-1.611,1.421,1.421,0,0,1,.218-.008,1.391,1.391,0,0,1,.977.391,1.6,1.6,0,0,1,.475,1.229V42.9a1.3,1.3,0,1,0,2.6,0V35.552a1.44,1.44,0,0,1,1.251-1.609,1.618,1.618,0,0,1,.2-.011,1.416,1.416,0,0,1,1.005.391,1.581,1.581,0,0,1,.447,1.229v8.741a1.313,1.313,0,0,0,2.625,0v-5a1.44,1.44,0,0,1,1.251-1.609,1.618,1.618,0,0,1,.2-.011,1.416,1.416,0,0,1,1.005.391,1.581,1.581,0,0,1,.447,1.229V52.476Z"
                        transform="translate(0)"
                        fill={props.fill}
                    />
                </g>
            </g>
        </svg>
    );
}
